const Ruling = require('./ruling');
const Format = require('./format-legality');
const CardDetailService = require('../../services').Cards;
const template = require('./rulings.tpl').default;

module.exports = DomClass(template, function() {
	var _t = this;

	this.cardName = this.card.name;
	this.playFormats = [
		'commander',
		'standard',
		'modern',
		'legacy',
		'vintage',
		'duel'
	];
	var ondetails = on(this, 'details');

	var showRulings = function() {
		// naughty way to deal with cards that don't exist, don't have
		// rulings, don't even have a ruling property, etc...
		try {
			var rulings = _t.card.rulings.map(function(ruling) {
				return new Ruling(ruling);
			});
			_t.rulings = rulings;
		} catch (ex) {
			_t.rulings = '--- no rulings ---';
		}
	};

	var showLegalities = function() {
		_t.legalities = _t.playFormats.map(function(format) {
			return new Format({
				name: format,
				legality: _t.card?.legalities[format]
			});
		});
		_t.card && on(this, 'legalities').fire(_t.card.legalities);
	};

	this.show = function(card) {
		_t.card = card; // || this.card;
		showRulings();
		showLegalities();
	};

	// Conditional re-fetch of CardDetail should become obsolete over time.
	if (this.card.rulings && this.card.legalities) {
		this.show(this.card)
	} else {
		CardDetailService.get(this.card.name).then(function(card) {
			_t.show(card);
			ondetails.fire(_t);
		});
	}

});
